import { configureStore } from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'
import config from 'src/config'

import { wishlistAccountMiddleware } from './wishlistAccount'
import rootReducer from './reducer'
import commerceTrackingMiddleware from './commerceTrackingMiddleware'

export let store: ReturnType<typeof configStore>

const { dev } = config

const configStore = () => configureStore({
  reducer: rootReducer,
  devTools: dev,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(commerceTrackingMiddleware, wishlistAccountMiddleware),
})

export const makeStore = () => {
  store = configureStore({
    reducer: rootReducer,
    devTools: dev,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(commerceTrackingMiddleware, wishlistAccountMiddleware),
  })
  return store
}

export const storeWrapper = createWrapper(makeStore, {
  debug: false,
})
